import { SvgIconComponent } from "@mui/icons-material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Typography,
} from "@mui/material";
import { ShineBorder } from "src/components/ShineBorder/ShineBorder";

/**
 * According with a bubble style
 */
export const BubbleAccordion = ({
  children,
  expandedId,
  title,
  subtitle,
  Icon,
  id,
  handleChange,
  hasShineBorder = false,
}: {
  children: React.ReactNode;
  expandedId: number | false;
  title: string;
  subtitle: string;
  Icon: SvgIconComponent;
  id: number;
  handleChange: (
    id: number
  ) => (_: React.SyntheticEvent, isExpanded: boolean) => void;
  hasShineBorder?: boolean;
}) => {
  const expanded = expandedId === id;
  return (
    <Accordion
      expanded={expanded}
      onChange={handleChange(id)}
      className={`rounded-md my-2 border border-gray-100 border-solid shadow-sm`}
      disableGutters
      sx={{
        "&:before": {
          display: "none",
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel${id}bh-content`}
        id={`panel${id}bh-header`}
        className="rounded-md border"
        sx={{
          "& .MuiAccordionSummary-content": {
            flexDirection: "row",
            justifyContent: "normal",
          },
        }}
      >
        {!expanded && hasShineBorder && (
          <div className="rounded-md">
            <ShineBorder />
          </div>
        )}
        <Icon fontSize="small" className="text-gray-600" />
        <Typography
          component="span"
          variant="body1"
          className="text-gray-600 ml-2 font-bold"
        >
          {title}
        </Typography>
        <Typography
          component="span"
          variant="body2"
          className="text-gray-600 ml-2"
        >
          - {subtitle}
        </Typography>
      </AccordionSummary>
      <AccordionDetails className="bg-white rounded-md m-4 mt-0 p-4 pt-0">
        <Divider className="mb-4 mx-auto" />
        {children}
      </AccordionDetails>
      {hasShineBorder && (
        <div className="rounded-md">
          <ShineBorder />
        </div>
      )}
    </Accordion>
  );
};
